import React, { useState, useEffect } from 'react';
import SidebarNavigation from '../../components/ui/SidebarNavigation';
import NavigationToggle from '../../components/ui/NavigationToggle';
import BreadcrumbTrail from '../../components/ui/BreadcrumbTrail';
import WelcomeSection from './components/WelcomeSection';
import ActionCards from './components/ActionCards';
import RecentActivityFeed from './components/RecentActivityFeed';
import QuickStatsPanel from './components/ QuickStatsPanel';

const DashboardOverview = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [loading, setLoading] = useState(true);

  // Mock user data
  const userData = {
    name: 'احمد محمدی',
    plan: 'پلن طلایی',
    credits: 12,
    role: 'کاربر ویژه',
  };

  // Mock statistics data
  const statsData = {
    totalRequests: 24,
    pendingRequests: 3,
    completedRequests: 18,
    creditsUsedToday: 2,
  };

  // Mock recent activities data
  const recentActivities = [
    {
      id: 1,
      caseType: 'اظهارنامه قضایی',
      subject: 'اظهارنامه مربوط به دعوای ملکی خانم زهرا احمدی',
      status: 'completed',
      createdAt: '2025-11-01T10:30:00Z',
    },
    {
      id: 2,
      caseType: 'شکایت',
      subject: 'شکایت از شرکت پیمانکاری بابت عدم انجام تعهدات',
      status: 'draft',
      createdAt: '2025-10-30T14:15:00Z',
    },
    {
      id: 3,
      caseType: 'لایحه',
      subject: 'لایحه دفاعیه در پرونده کیفری شماره ۱۴۰۳۰۹۸۷۶۵۴۳',
      status: 'processing',
      createdAt: '2025-10-29T09:45:00Z',
    },
    {
      id: 4,
      caseType: 'اظهارنامه قضایی',
      subject: 'اظهارنامه طلب مهریه و نفقه معوقه',
      status: 'pending',
      createdAt: '2025-10-28T16:20:00Z',
    },
    {
      id: 5,
      caseType: 'شکایت',
      subject: 'شکایت از بانک بابت برداشت غیرمجاز از حساب',
      status: 'completed',
      createdAt: '2025-10-27T11:10:00Z',
    },
  ];

  useEffect(() => {
    // Simulate loading data
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  const handleSidebarToggle = () => {
    setSidebarOpen(!sidebarOpen);
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-muted-foreground">در حال بارگذاری...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background" dir="rtl">
      {/* Navigation Toggle for Mobile */}
      <NavigationToggle isOpen={sidebarOpen} onToggle={handleSidebarToggle} />

      {/* Sidebar Navigation */}
      <SidebarNavigation
        isCollapsed={!sidebarOpen}
        onToggle={handleSidebarToggle}
      />

      {/* Main Content */}
      <div
        className={`transition-all duration-300 ease-in-out ${
          sidebarOpen ? 'lg:mr-80' : 'lg:mr-80'
        } mr-0`}>
        <div className="p-4 lg:p-8">
          {/* Breadcrumb */}
          <BreadcrumbTrail />

          {/* Welcome Section */}
          <WelcomeSection user={userData} />

          {/* Quick Stats Panel */}
          <QuickStatsPanel stats={statsData} />

          {/* Action Cards */}
          <ActionCards />

          {/* Recent Activity Feed */}
          <RecentActivityFeed activities={recentActivities} />
        </div>
      </div>

      {/* Mobile Sidebar Overlay */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-30 lg:hidden"
          onClick={handleSidebarToggle}
        />
      )}
    </div>
  );
};

export default DashboardOverview;
